import ServerConfig from '@core/models/country/ServerConfig';
import CTRestRequestFactory from '@core/utils/network/CTRestRequestFactory';

export default class RestService {
    private readonly request: any;

    constructor(config: ServerConfig, restRequestFactory = CTRestRequestFactory) {
        this.request = restRequestFactory.create(config.bonus.host, true);
    }

    /**
     * @throws {RequestError}
     */
    public setBonus(code: string): Promise<any> {
        return this.request({
            url: '/bonus/bonusOptIn',
            method: 'post',
            data: {
                code,
            },
        });
    }

    /**
     * @throws {RequestError}
     */
    public setNoBonus(): Promise<any> {
        return this.request({
            url: '/bonus/bonusOptOut',
            method: 'post',
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/bonus/_private/RestService.ts